import SkeletonElement from "./SkeletonElement";
import styles from "./SkeletonFoodJournalList.module.scss";
import SkeletonShimmer from "./SkeletonShimmer";

export default function SkeletonFoodJournalList() {
  return (
    <div>
      {Array.from(Array(3).keys()).map((index) => (
        <div className={`skeleton-wrapper ${styles.wrapper}`} key={index}>
          <SkeletonElement type="image" />
          <SkeletonElement type="text" />
          <SkeletonShimmer />
        </div>
      ))}
    </div>
  );
}
